import { useKeycloak } from '@react-keycloak/web';

export const ROLES = {
  ORG_VIEWER: 'org-viewer',
  ORG_ADMIN: 'org-admin',
  ORG_SURVEY_ANALYST: 'org-survey-analyst',
  ORG_SURVEY_LEAD: 'org-survey-lead',
  ORG_ENABLER_SUPER_ADMIN: 'org-enabler-super-admin',
};

export const useUserRoles = () => {
  const { keycloak } = useKeycloak();
  return keycloak.tokenParsed?.realm_access?.roles || [];
};

export const useHasRole = (role) => {
  const roles = useUserRoles();
  return roles.includes(role);
};

export const useGroupName = () => {
  const { keycloak } = useKeycloak();

  const group = keycloak.tokenParsed?.groups?.[0] || '';
  console.log(`group from keycloak: ${group}`);
  return group.startsWith('/') ? group.slice(1) : group;
};